import SucursalInfoStore from "./SucursalInfoStore";
import SucursalListStore from "./SucursalListStore";
import SucursalUpsertStore from "./SucursalUpsertStore";

const SucursalStore = {
  info: SucursalInfoStore,
  list: SucursalListStore,
  upsert: SucursalUpsertStore,
}

export default SucursalStore;